import { Typography } from '@mui/material';
import { colors } from './../../../lib/theme';
import styled, { css, keyframes } from 'styled-components';

const { businessCardBg } = colors;

export const SectionWrapper = styled.section<{ $background?: string }>`
  width: 100%;
  background: ${({ $background }) => $background ?? '#F5F7FD'};
  padding: 4rem 0;

  @media only screen and (max-width: 768px) {
    padding: 2.5rem 0;
  }
`;

export const Title = styled(Typography)`
  font-family: 'Impact';
  font-size: 30px;
  text-align: center;
  color: ${businessCardBg};
  @media only screen and (max-width: 768px) {
    /* For mobile phones: */
    font-size: 16px;
  }
`;

export const MainWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 3rem;
  @media only screen and (max-width: 768px) {
    /* For mobile phones: */
    margin: 1rem;
  }
`;

export const Description = styled(Typography)`
  font-size: 20px;
  white-space: pre-line;
  text-align: center;
  font-weight: bold;
  @media only screen and (max-width: 768px) {
    /* For mobile phones: */
    font-size: 14px;
  }
`;

export const CardsWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 30px;
  margin-top: 3rem;
  @media only screen and (max-width: 768px) {
    /* For mobile phones: */
    display: flex;
    grid-gap: 0;
    flex-direction: column;
  }
`;

export const AccountCreationWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px; // margin-top: 3rem;
`;

export const LogoSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 3rem;
  gap: 1.5rem;
`;

export const LogoCarouselWrapper = styled.div<{ $isScrollable: boolean }>`
  position: relative;
  width: 100%;
  overflow: hidden;
  padding: 1.5rem 0;
  display: flex;
  justify-content: ${({ $isScrollable }) =>
    $isScrollable ? 'flex-start' : 'center'};
`;

const scrollLogos = keyframes`
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
`;

export const LogoTrack = styled.div<{ $isScrollable: boolean; $duration?: number }>`
  display: flex;
  align-items: center;
  gap: 2.5rem;
  width: ${({ $isScrollable }) => ($isScrollable ? 'max-content' : '100%')};
  justify-content: ${({ $isScrollable }) =>
    $isScrollable ? 'flex-start' : 'center'};
  ${({ $isScrollable, $duration }) =>
    $isScrollable
      ? css`
          animation: ${scrollLogos} ${$duration || 20}s linear infinite;
        `
      : css`
          animation: none;
        `}
`;

export const LogoItem = styled.div`
  flex: 0 0 auto;
  width: 140px;
  height: 80px;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;

  @media only screen and (max-width: 768px) {
    width: 120px;
    height: 70px;
  }
`;

export const LogoImage = styled.img`
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
`;
